import { render, staticRenderFns } from "./v-contrib-div.vue?vue&type=template&id=a31b5ed4"
import script from "./v-contrib-div.vue?vue&type=script&lang=js"
export * from "./v-contrib-div.vue?vue&type=script&lang=js"
import style0 from "./v-contrib-div.vue?vue&type=style&index=0&id=a31b5ed4&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports